import { FormattedMessage } from 'react-intl';

import { Modal } from '../common/Modal';

export interface ExampleModalProps {
	isOpen: boolean;
	images: ExampleModalImage[];
	headerTitleId: string | null;
	closeTitleId: string | null;
	name: string | null;
	onClose: () => void;
}

export interface ExampleModalImage {
	src: string;
}

export const ExampleModal = (props: ExampleModalProps) => {
	const headerTitleId = props.headerTitleId || 'imageRecognitionFeedback2.exemplaryPhoto';
	const closeTitleId = props.closeTitleId || 'button.close';

	return (
		<Modal
			isOpen={props.isOpen}
			closeOnBackdropClick={true}
			onClose={props.onClose}
			className="select-image-modal"
			header={
				<h2 className="example-modal-title">
					<FormattedMessage id={headerTitleId} />
				</h2>
			}
			footer={
				<button onClick={props.onClose}>
					<FormattedMessage id={closeTitleId} />
				</button>
			}
		>
			<>
				{props.isOpen && !!props.images
					? props.images.map((image, index) => (
							<img
								className={`example-modal-image example-modal-image-${props.name !== null ? `${props.name}-` : ''}${index}`}
								key={index}
								src={image.src}
								alt=""
							/>
						))
					: null}
			</>
		</Modal>
	);
};
